import styled from "@emotion/styled/macro";
import rem from "../../utils/rem/rem";

export const EditButton = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    border: none;
    background-color: transparent;
    cursor: pointer;
    font-size: ${rem(28)};
    width: ${rem(44)};
    height: ${rem(44)};
    color: ${({ theme }) => theme.colors.gray600};
    &:focus {
      outline: none;
    }
    &:focus svg {
      ${({ theme }) => theme.states.focus};
    }
`;